/**
 * Full-screen overlay shown while a long save (submit / approve /
 * update / cancel) is in flight. The propeller SVG rotates via Tailwind
 * `animate-spin` and the whole stack is fixed center so it works on
 * mobile and desktop. Pure presentation — caller controls visibility
 * via the `open` prop.
 */
export function SavingOverlay({
  open,
  label = "Guardando…",
}: {
  open: boolean;
  label?: string;
}) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-2 bg-white/40 backdrop-blur-[1px]"
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <Propeller />
      <p className="text-xs font-medium text-brand-900/80">{label}</p>
    </div>
  );
}

function Propeller() {
  return (
    <svg
      className="h-10 w-10 animate-spin text-brand-700/80"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
    >
      {/* Three rounded blades around a central hub — minimal aviation
          cue without an icon library. */}
      <g fill="currentColor">
        <ellipse cx="32" cy="14" rx="5" ry="14" />
        <ellipse
          cx="32"
          cy="14"
          rx="5"
          ry="14"
          transform="rotate(120 32 32)"
        />
        <ellipse
          cx="32"
          cy="14"
          rx="5"
          ry="14"
          transform="rotate(240 32 32)"
        />
        <circle cx="32" cy="32" r="5" fill="#0f2e4d" />
      </g>
    </svg>
  );
}
